import Card from '../../../Card';
import { CheckSolidIcon } from '../../../Icons';
import styles from './styles.module.scss';

const Item = ({ label }: { label: string }) => {
    return (
        <li className={styles.item}>
            <span className={styles.iconWrapper}>
                <CheckSolidIcon />
            </span>
            {label}
        </li>
    );
};

export const GuaranteesCard = () => {
    return (
        <Card>
            <ul className={styles.list}>
                <Item label="30 Day Money Back Guarantee" />
                <Item label="Completion Certificate" />
                <Item label="24/7 Technical Support" />
            </ul>
        </Card>
    );
};

export default GuaranteesCard;
